import { CreateCanvas } from "./CreateCanvas";
import { Globals } from "../CoreApp/Globals";

export function CreateMeasureBuffer() {
  if (Globals._measureBuffer == null) {
    Globals._measureBuffer = CreateCanvas();
    Globals._measureBuffer.width = 1200;
    Globals._measureBuffer.height = 400;
  }
}
